const initialState = {
    processes: [], // Array of ongoing processes
    completedProcesses: [], // Array of recently completed processes
    notifications: [], // Array of unread notifications
    currentProcessId: null, // ID of the most recently created process
};

const backgroundProcessesReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'ADD_PROCESS':
            return {
                ...state,
                processes: [...state.processes, action.payload],
                currentProcessId: action.payload.id,
            };

        case 'UPDATE_PROCESS':
            return {
                ...state,
                processes: state.processes.map(process =>
                    process.id === action.payload.id
                        ? { ...process, ...action.payload.updates }
                        : process
                ),
            };

        case 'COMPLETE_PROCESS': {
            const process = state.processes.find(p => p.id === action.payload);
            if (!process) return state;

            return {
                ...state,
                processes: state.processes.filter(p => p.id !== action.payload),
                completedProcesses: [
                    ...state.completedProcesses,
                    { ...process, completedAt: new Date().toISOString(), status: 'completed' }
                ],
                currentProcessId: state.currentProcessId === action.payload ? null : state.currentProcessId,
                notifications: [
                    ...state.notifications,
                    {
                        id: `notif-${Date.now()}`,
                        processId: action.payload,
                        message: `Process "${process.name}" completed successfully`,
                        type: 'success',
                        read: false,
                        createdAt: new Date().toISOString(),
                        redirectPath: process.redirectPath,
                    }
                ],
            };
        }

        case 'FAIL_PROCESS': {
            const process = state.processes.find(p => p.id === action.payload.id);
            if (!process) return state;

            return {
                ...state,
                processes: state.processes.filter(p => p.id !== action.payload.id),
                completedProcesses: [
                    ...state.completedProcesses,
                    { ...process, completedAt: new Date().toISOString(), status: 'failed', error: action.payload.error }
                ],
                currentProcessId: state.currentProcessId === action.payload.id ? null : state.currentProcessId,
                notifications: [
                    ...state.notifications,
                    {
                        id: `notif-${Date.now()}`,
                        processId: action.payload.id,
                        message: `Process "${process.name}" failed: ${action.payload.error}`,
                        type: 'error',
                        read: false,
                        createdAt: new Date().toISOString(),
                        redirectPath: process.redirectPath,
                    }
                ],
            };
        }

        case 'REMOVE_PROCESS':
            return {
                ...state,
                processes: state.processes.filter(p => p.id !== action.payload),
                currentProcessId: state.currentProcessId === action.payload ? null : state.currentProcessId,
            };

        case 'SET_CURRENT_PROCESS_ID':
            return {
                ...state,
                currentProcessId: action.payload,
            };

        case 'CLEAR_CURRENT_PROCESS_ID':
            return {
                ...state,
                currentProcessId: null,
            };

        case 'MARK_NOTIFICATION_READ':
            return {
                ...state,
                notifications: state.notifications.map(notif =>
                    notif.id === action.payload
                        ? { ...notif, read: true }
                        : notif
                ),
            };

        case 'MARK_ALL_NOTIFICATIONS_READ':
            return {
                ...state,
                notifications: state.notifications.map(notif => ({ ...notif, read: true })),
            };

        case 'REMOVE_NOTIFICATION':
            return {
                ...state,
                notifications: state.notifications.filter(n => n.id !== action.payload),
            };

        case 'CLEAR_COMPLETED_PROCESSES':
            return {
                ...state,
                completedProcesses: [],
            };

        case 'LOGOUT':
            return initialState;

        case 'CLEAR_ALL_NOTIFICATIONS':
            return {
                ...state,
                notifications: [],
            };

        case 'ADD_NOTIFICATION': {
            const notification = action.payload;
            if (!notification?.id) return state;
            if (state.notifications.some((n) =>
                n.id === notification.id ||
                (notification.rewardId && n.rewardId === notification.rewardId)
            )) return state;

            return {
                ...state,
                notifications: [...state.notifications, notification],
            };
        }

        default:
            return state;
    }
};

export default backgroundProcessesReducer;
